module.exports = __webpack_public_path__ + "img/error.29660b6e.svg";